import React, { useState } from "react";
import "./ChatWidget.css";

const ChatWidget = () => {
  const [open, setOpen] = useState(false);

  const sendWhatsapp = (text) => {
    window.open(`https://wa.me/919818119099?text=${encodeURIComponent(text)}`, "_blank");
  };

  return (
    <>
      {/* Chatbox */}
      {open && (
        <div className="chat-box">
          <div className="chat-header">
            <img src="/whatsapp.jpg" className="chat-icon" alt="" />
            <div>
              <h4>Niveshly Support</h4>
              <p>Typically replies in 2–5 minutes</p>
            </div>

            <button className="close-btn" onClick={() => setOpen(false)}>×</button>
          </div>

          <div className="chat-body">
            <div className="bot-message">
              👋 Hi! How can we help you today?
            </div>

            <div className="quick-buttons">
              <button onClick={() => sendWhatsapp("Hi, I need investment guidance")}>
                Investment Guidance
              </button>

              <button onClick={() => sendWhatsapp("I want to know about your services")}>
                Services Info
              </button>

              <button onClick={() => sendWhatsapp("Need help using the website")}>
                Website Support
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Floating Buttons */}
      <div className="floating-container">
        
        {/* WhatsApp Floating Button */}
        <div className="floating-btn img " onClick={() => setOpen(!open)}>
          <img src="/whatsapp.jpg" alt="WhatsApp" />
        </div>

        {/* Call Floating Button */}
        <a href="tel:+919818119099" className="floating-btn call-btn">
          <img src="/call.png" alt="Call" />
        </a>
      </div>
    </>
  );
};

export default ChatWidget;
